import { render, staticRenderFns } from "./SidebarNavList.vue?vue&type=template&id=b2842154&scoped=true&"
import script from "./SidebarNavList.vue?vue&type=script&lang=js&"
export * from "./SidebarNavList.vue?vue&type=script&lang=js&"
import style0 from "./SidebarNavList.vue?vue&type=style&index=0&id=b2842154&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2842154",
  null
  
)

export default component.exports